export default "__VITE_ASSET__CH4uo5Ex__"